export var ECardType;
(function (ECardType) {
    ECardType["IMAGE"] = "IMAGE";
    ECardType["TEXT"] = "TEXT";
    ECardType["MOJ_DENAR"] = "MOJ_DENAR";
    ECardType["MATCH"] = "MATCH";
    ECardType["SHOP"] = "SHOP";
    ECardType["SINGLE_IMAGE"] = "SINGLE_IMAGE";
    ECardType["SINGLE_TEXT"] = "SINGLE_TEXT";
    ECardType["DOUBLE_IMAGE"] = "DOUBLE_IMAGE";
    ECardType["DOUBLE_TEXT"] = "DOUBLE_TEXT";
    ECardType["SINGLE_VIDEO"] = "SINGLE_VIDEO";
    ECardType["DOUBLE_VIDEO"] = "DOUBLE_VIDEO";
    ECardType["SINGLE_SHOP_ITEM"] = "SINGLE_SHOP_ITEM";
    ECardType["PLAYER_SINGLE"] = "PLAYER_SINGLE";
    ECardType["PLAYER_DOUBLE"] = "PLAYER_DOUBLE";
    ECardType["SINGLE_MATCH"] = "SINGLE_MATCH";
    ECardType["WIDE_PAST_MATCH"] = "WIDE_PAST_MATCH";
    ECardType["WIDE_UPCOMING_MATCH"] = "WIDE_UPCOMING_MATCH";
})(ECardType || (ECardType = {}));
